export default __webpack_public_path__ + "static/media/jdedwards.8d141938.png";